namespace $ {
	export type $shm_hitalama_guide_document_data = { title: string, body: string, links: { page: string, title: string }[], parent?: string }
	export class $shm_hitalama_guide_document extends $giper_baza_entity.with({ File: $giper_baza_atom_link.to( ()=> $giper_baza_file ), Parent: $giper_baza_atom_text }) {
		@ $mol_mem
		parent( next?: string ): string {
			if(next!==undefined){this.Parent(null)!.val(next);return next}
			const atom=this.Parent();if(atom)this.$.$shm_hitalama_map_component_ready.read(atom)
			return atom ? atom.val() ?? '' : this.read().parent ?? ''
		}
		@ $mol_mem
		private pending() { return new $mol_promise_blocker<void>() }
		read(): $shm_hitalama_guide_document_data {
			this.$.$shm_hitalama_map_component_ready.read( this )
			const source = this.File()
			if( source ) this.$.$shm_hitalama_map_component_ready.read( source )
			const file = source?.remote()
			// The manifest can arrive before the linked page's file pointer. Keep
			// the native atom subscription instead of showing an editable empty page.
			if( !file ) return $mol_fail_hidden( this.pending() )
			this.$.$shm_hitalama_map_component_ready.read( file )
			const chunks = file.Chunks()
			if( chunks ) this.$.$shm_hitalama_map_component_ready.read( chunks )
			return JSON.parse( file.str() )
		}
		allocate( snapshot: string ) { return this.land().area_make().Data( this.$.$giper_baza_file ) }
		@ $mol_action
		write( snapshot: string, expected: string ) {
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение руководства.' )
			const data = JSON.parse( snapshot ) as $shm_hitalama_guide_document_data
			if( !data.title.trim() || !Array.isArray( data.links ) ) throw new Error( 'Укажите название страницы и корректные ссылки.' )
			if( new TextEncoder().encode( snapshot ).length > 1048576 ) throw new Error( 'Страница больше 1 МиБ.' )
			const current = this.File()?.remote()?.link().str ?? ''
			if( current !== expected ) {
				if( JSON.stringify( this.read() ) === snapshot ) return
				throw new Error( 'Страница изменена другим пользователем. Сохраните черновик и перечитайте страницу.' )
			}
			const file = $mol_wire_sync( this ).allocate( snapshot )
			file.str( snapshot ); file.name( 'page.json' )
			this.File( null )!.remote( file )
		}
	}
}
